import api from '@/store/api/reservation'
import * as mutationTypes from './mutation-types'
import { handleApiCall } from '@/store/utils'

// Modules
import number from './number'

const initialState = () => ({
    numbers: {
        data: [],
        pagination: {}
    },
    areaCodes: {
        data: [],
        pagination: {}
    },
})

export default {
    namespaced: true,
    state: initialState(),
    modules: {
        number,
    },
    getters: {
        numbers: state => state.numbers.data,
        pagination: state => state.numbers.pagination,
        areaCodes: state => state.areaCodes.data,
    },
    actions: {
        listNumbers: ({ commit, dispatch }, data) => handleApiCall({ commit, dispatch }, api.listNumbers, data, mutationTypes.SET_RESERVATION_NUMBERS, true),
        listAreaCodes: ({ commit, dispatch }, data) => handleApiCall({ commit, dispatch }, api.listAreaCodes, data, mutationTypes.SET_AREA_CODES, true),
        resetNumbers: ({commit}) => commit(mutationTypes.RESET_RESERVATION_NUMBERS),
        resetAreaCodes: ({commit}) => commit(mutationTypes.RESET_AREA_CODES),
    },
    mutations: {
        [mutationTypes.SET_RESERVATION_NUMBERS]: (state, data) => state.numbers = data,
        [mutationTypes.RESET_RESERVATION_NUMBERS]: (state) => state.numbers = initialState().numbers,
        [mutationTypes.SET_AREA_CODES]: (state, data) => state.areaCodes = data,
        [mutationTypes.RESET_AREA_CODES]: (state) =>  state.areaCodes = initialState().areaCodes,
    }
}
